import { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import LeaderboardContent from "./LeaderboardContent";

const startTimestamp = 1636411849;
const campaginDuration = 7; // day, including today
const oneDayDuration = 86400;
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function Leaderboard() {
  const [tabIndex, setTabIndex] = useState(0);

  const originalDates: number[] = [startTimestamp].concat(
    Array<number>(campaginDuration - 1).fill(oneDayDuration)
  );
  const dates: number[] = [];
  originalDates.reduce(function (a, b, i) {
    return (dates[i] = a + b);
  }, 0);

  return (
    <div style={{ padding: "64px 30px 30px 30px" }}>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          {dates.map((e) => {
            var a = new Date(e * 1000);
            var month = months[a.getMonth()];
            var date = a.getDate();
            var time = date + " " + month;
            return <Tab key={e}>{time}</Tab>;
          })}
        </TabList>
        {dates.map((e, index) => {
          return (
            <TabPanel key={e}>
              <LeaderboardContent index={index} />
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
}

export default Leaderboard;
